







import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class TextInput extends Vue {
    @Prop({ type: String, required: true })
    label!: string;

    @Prop({ type: String, default: '' })
    value!: string;

    @Prop({ type: String, default: '请输入' })
    placeholder!: string;

    inputValue: string = '';

    debounceTimer: any = null;

    created() {
        this.inputValue = this.value;
    }

    beforeDestroy() {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
    }

    @Watch('value')
    onValueChange(newVal: string) {
        this.inputValue = newVal;
    }

    @Watch('inputValue')
    onInputChange(newVal: string) {
        this.$emit('input', newVal);
    }

    handleChange(value: string) {
        this.debounceEmit('change', value);
    }

    debounceEmit(eventName: string, value: string) {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
            this.$emit(eventName, value);
        }, 500);
    }
}
